// Eliminate the benign "ResizeObserver loop ..." dev-overlay error at its source.
// The loop happens when a ResizeObserver callback triggers another layout change
// synchronously (recharts ResponsiveContainer, auto-sizing tables, etc.). Deferring
// the callback to the next animation frame breaks the loop, so the browser never
// emits the notification — and CRA's dev overlay never sees it.
//
// This module is imported FIRST in index.tsx (before App and any library), so the
// patch is in place before any library captures the ResizeObserver constructor.
export {};

if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Safety net: swallow the notification if it still reaches window, so the dev
// overlay won't surface it.
const RESIZE_OBSERVER_LOOP =
  /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener(
  'error',
  (e) => {
    if (e.message && RESIZE_OBSERVER_LOOP.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
